import React from 'react';
import "./index.css";

function Results() {
    return(
<><br/>
<div className="result"><img className="testscore" src="https://cdn-icons-png.flaticon.com/128/782/782702.png" alt="지도 이미지"/>&nbsp;&nbsp;&nbsp;&nbsp;Results</div>
<br/>
<div className="student">

김포 2016년 ~ 현재까지 <br/>
공O희 (동두천 외고 합격)<br/>
김O우 (동두천 외고 합격)<br/>
박O희 (북일고(자사고) 합격)<br/>
이0우 (안산동산고(자사고) 합격)<br/>
이0성 (한민고 합격) <br/>
박0은 (동두천 외고 합격) <br/>
박0우 (동두천 외고 합격) <br/>
백0원 (고양외고 합격) <br/>
<br/><br/>
2007년 ~ 2014년 <br/>
정O연 (명덕외고 합격-자기소개서 첨삭)<br/>
최O나 (8년 수업. 고양외고 합격-자기소개서 첨삭)<br/>
전O서 (8년 수업. 삼육중(사립중학교 시험 합격-자기소개서 첨삭), 서울외고 합격) <br/>
전O수 (7년 수업. 대일외고 합격-자기소개서 첨삭)<br/>
염O진 (7년 수업. 서울외고 합격) <br/>
김0오 (7년 수업. 광양제철고(자사고) 합격) <br/>
권0찬 (4년 수업. 삼육(사립)중학교 합격)<br/>
강0서 (동두천 외고 합격)<br/>
김0수 (삼육고등학교 합격)




</div>
<br/><br/>

</>

    );

}

export default Results;